import { memo, useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
//Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import useLocations from 'hooks/useLocations';
import { locationsSelectors } from 'features/locations';

const LocationsDetails = () => {
  const { setLocationDrawer } = useApp();
  const { clearLocalActiveLocation } = useLocations();
  const { name, display_name, address, synchronized, slots_count, updated_at } = useCustomSelector(locationsSelectors.getLocationData);
  const lastUpdate = new Date(updated_at).toLocaleDateString('en-US');

  useEffect(() => {
    return clearLocalActiveLocation;
  }, [clearLocalActiveLocation]);

  return (
    <Box sx={{ flexGrow: 1, overflow: 'auto', p: 5  }}>
      <Container maxWidth={'sm'}>
        <Card sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '8px', mb: 1.5 }}>

            <Typography sx={{ fontSize: '1.5rem', fontWeight: 800 }}>{name}</Typography>
            <Button variant='outlined' onClick={() => setLocationDrawer({ open: true, edit: true })}>Edit</Button>
          </Box>
          <Typography variant='subtitle1'>Address: {address ?? '-'}</Typography>
          <Typography variant='subtitle1'>Display Name: {display_name ?? '-'}</Typography>
          <Typography variant='subtitle1'>EHR match status: {synchronized ? 'Connected' : 'Not connected'}</Typography>
          <Typography variant='subtitle1'>Slots Count: {slots_count}</Typography>
          <Typography variant='body1' mb={2}>Last Update: {lastUpdate}</Typography>
        </Card>
      </Container>
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <LocationsDetails {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);